import React, {useEffect, useState} from 'react';
import {t} from "i18next";
import {useAuth} from "@/hooks/useAuth";
import {Transition, TransitionChild} from "@headlessui/react";
import {bookTicket} from "@/service/eventApi";
import {toast} from "react-toastify";
import Cookies from "universal-cookie";
import {ChevronDownIcon} from "@radix-ui/react-icons";
import {useAxiosPrivate} from "@/hooks/useAxiosPrivate";

export const EventRegistrationForm = (props) => {
	const {
		setEventsData,
		showEventRegistrationModal,
		setShowEventRegistrationModal,
		selectedModeOfAttending,
		setSelectedModeOfAttending,
		selectedEventDetails,
		setSelectedEventDetails,
		setEventPaymentQRModalConfig,
		setShowEventTicketModal,
		setSelectedTicketDetails
	} = props;

	const cookies = new Cookies();
	const locale = cookies.get("locale");
	const axiosPrivate = useAxiosPrivate();

	const {account} = useAuth();

	// Occupation Details Variables
	const [isOccupationTypeDropdownOpen, setIsOccupationTypeDropdownOpen] = useState(false);
	const [isSelectingOccupationType, setIsSelectingOccupationType] = useState(false);

	const [occupationDetails, setOccupationDetails] = useState({
		type: "Business",
		name: ""
	});

	const [occupationTypeOtherName, setOccupationTypeOtherName] = useState("");

	const [isBookTicketButtonDisabled, setIsBookTicketButtonDisabled] = useState(false);

	// Number of Seats Variables
	const [is1SeatSelected, setIs1SeatSelected] = useState(false);
	const [is2SeatsSelected, setIs2SeatsSelected] = useState(false);

	// Food Consent Variables
	const [isFoodConsentYesSelected, setIsFoodConsentYesSelected] = useState(false);
	const [isFoodConsentNoSelected, setIsFoodConsentNoSelected] = useState(false);

	// Ticket Details Variables
	const [ticketDetails, setTicketDetails] = useState({
		userId: account._id,
	});

	// Mode of Attending Functions
	const modeOfAttendingDetails = (selectedModeOfAttending) => {
		switch (selectedModeOfAttending) {
			case "VIRTUAL":
				return {
					label: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.VIRTUAL.LABEL"),
					info: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.VIRTUAL.MESSAGE"),
					icon: "/assets/zoom-company-icon.svg"
				}
			case "PHYSICAL" && selectedEventDetails.isTicketed:
				return {
					label: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.PHYSICAL.LABEL"),
					info: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.PHYSICAL.MESSAGE"),
					icon: "/assets/location-icon-filled.svg"
				}
			default:
				return {
					label: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.DEFAULT"),
				}
		}
	}

	// Occupation Details Functions
	const occupationTypeLabel = (occupationType) => {
		switch (occupationType) {
			case 'Business':
				return t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.BUSINESS");
			case 'Service Professional':
				return t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.SERVICE_PROFESSIONAL");
			case 'Entrepreneur':
				return t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.ENTREPRENEUR");
			case 'Freelancer':
				return t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.FREELANCER");
			case 'Self Employed':
				return t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.SELF_EMPLOYED");
			case 'Investor':
				return t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.INVESTOR");
			case 'Student':
				return t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.STUDENT");
			case 'Other':
				return t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.OTHER");
			default:
				return t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.OTHER");
		}
	}

	const handleOccupationTypeSelect = (occupationType) => {
		setIsSelectingOccupationType(false);
		setIsOccupationTypeDropdownOpen(false);
		setOccupationDetails(prev => ({
			...prev,
			type: occupationType
		}));
	}

	// Number of Seats Functions
	const handleNumberOfSeatsSelect = (selectedNumberOfSeats) => {
		if (selectedNumberOfSeats !== ticketDetails.numberOfSeats) {
			setTicketDetails(prevState => {
				return {
					...prevState,
					numberOfSeats: selectedNumberOfSeats
				}
			});
		}
	}

	const numberOfSeatsLabel = (selectedNumberOfSeats) => {
		switch (selectedNumberOfSeats) {
			case 1:
				return {
					label: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.NUMBER_OF_SEATS.SEATS.ONE"),
				}
			case 2:
				return {
					label: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.NUMBER_OF_SEATS.SEATS.TWO"),
				}
			default:
				return {
					label: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.NUMBER_OF_SEATS.SEATS.ONE"),
				}
		}
	}

	// Food Consent Functions
	const handleFoodConsentSelect = (selectedFoodConsent) => {
		if (selectedFoodConsent !== ticketDetails.foodConsent) {
			setTicketDetails(prevState => {
				return {
					...prevState,
					foodConsent: selectedFoodConsent
				}
			});
		}
	}

	const handleSubmit = async () => {
		console.log("Inside Handle Submit!");
		// setIsBookTicketButtonDisabled(true);

		console.log("Ticket Details: ", ticketDetails);
		console.log("Selected Event Details: ", selectedEventDetails);

		if (selectedEventDetails.isTicketed && !ticketDetails.numberOfSeats) {
			toast.error(t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.NUMBER_OF_SEATS.EMPTY_INPUT_ERROR"));
			return;
		}

		if (selectedEventDetails.occupationDetailsRequired) {
			if (occupationDetails.type === "Other" && !occupationTypeOtherName) {
				toast.error(t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OTHER_OCCUPATION.EMPTY_INPUT_ERROR"));
				return;
			}

			if (!occupationDetails.name) {
				toast.error(t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.NAME.EMPTY_INPUT_ERROR"));
				return;
			}
		}

		if (selectedEventDetails.manualPaymentConfirmationRequired) {
			console.log("(EventRegistrationForm.jsx) Manual Payment Confirmation Required: ", selectedEventDetails);
			try {
				console.log("(EventRegistrationForm.jsx) Inside try block | Manual Payment Confirmation Required: ", selectedEventDetails);

				const result = await new Promise((resolve, reject) => {
					// UPDATE STATE FIRST
					setEventPaymentQRModalConfig({
						show: true,
						resolve: resolve,
						reject: reject
					});
				});

				console.log("(EventRegistrationForm) Payment result, for the event: ", selectedEventDetails);

				if (result.status === "success") {
					console.log("(EventRegistrationForm) Payment confirmed by user!");
					setEventPaymentQRModalConfig({show: false});
				}
			} catch (error) {
				console.log("(EventRegistrationForm) Payment cancelled by user, for the event: ", selectedEventDetails);
				setEventPaymentQRModalConfig({show: false});
				return;
			}
		}

		const ticketData = {
			...ticketDetails,
			foodConsent: ticketDetails.foodConsent ? ticketDetails.foodConsent : false,
			eventId: selectedEventDetails._id,
			modeOfAttending: selectedModeOfAttending,
			occupationDetails: {
				type: occupationDetails.type,
				name: occupationDetails.name,
				occupationTypeOtherName: occupationTypeOtherName
			}
		}

		console.log("(EventRegistrationForm) Book Ticket Data: ", ticketData);

		const bookTicketResponse = await bookTicket(axiosPrivate, ticketData);
		console.log('(EventRegistrationForm) Book Tickets Response: ', bookTicketResponse);

		if (bookTicketResponse.success) {
			setShowEventRegistrationModal(false);
			setIsBookTicketButtonDisabled(false);

			setSelectedModeOfAttending("");

			// Updating the events data with the booked ticket details
			setEventsData(prevState => {
				return prevState.map(event => {
					if (event._id === selectedEventDetails._id) {
						return {
							...event,
							isTicketBooked: true,
							ticketDetails: bookTicketResponse.data
						}
					}
					return event;
				})
			});

			toast.success(t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_SUCCESS"));

			setShowEventTicketModal(true);
			setSelectedTicketDetails(bookTicketResponse.data);

			setTimeout(() => {
				setTicketDetails({
					userId: account._id
				});
			}, 200);
		} else {
			if (bookTicketResponse.message === "EVENT_HOUSE_FULL") {
				toast.warning(t("EVENTS_PAGE.REGISTRATION_FORM.HOUSE_FULL"));
			}
		}
	}

	const handleClose = () => {
		console.log("(EventRegistrationForm) Inside Handle Close!");

		setShowEventRegistrationModal(false);
		setIsBookTicketButtonDisabled(false);
		setTimeout(() => {
			setTicketDetails({
				userId: account._id
			});

			setSelectedModeOfAttending("");
			setSelectedEventDetails({
				id: "",
				title: "",
				bannerUrl: ""
			})
		}, 200);
	}

	useEffect(() => {
		console.log("(EventRegistrationForm) Show Event Registration Modal: ", showEventRegistrationModal);
		console.log("(EventRegistrationForm) Document Body Class List: ", document.body.classList);
	}, [showEventRegistrationModal]);

	return (
		<>
			{document.body.classList.toggle("!overflow-y-hidden", showEventRegistrationModal)}

			<Transition show={showEventRegistrationModal}>
				<div
					className={`min-h-[100dvh] h-[100dvh] max-h-[100dvh] 
                        min-w-[100dvw] w-[100dvw] max-w-[100dvw]
                        flex items-center justify-center 
                        fixed inset-0 z-[100]
                        bg-black/75 backdrop-blur-sm
                        data-[closed]:opacity-0
                        data-[enter]:duration-150 data-[enter]:data-[closed]:ease-out
                        data-[leave]:duration-300 data-[leave]:data-[closed]:ease-out`}
				>
					<TransitionChild
						enter="transition-transform duration-300 ease-out"
						enterFrom="translate-y-full"
						enterTo="translate-y-0"
						leave="transition-transform duration-300 ease-in"
						leaveFrom="translate-y-0"
						leaveTo="translate-y-full"
					>
						<div
							className="min-h-fit h-fit max-h-[100dvh]
                                landscape:min-w-[25vw] landscape:max-w-[90vw]

                                portrait:min-h-full portrait:h-full portrait:max-h-full
                                portrait:md:!min-h-fit portrait:md:!h-fit portrait:md:!max-h-fit

                                portrait:min-w-[100dvw] portrait:w-[100dvw] portrait:max-w-[100dvw]
                                portrait:md:min-w-[40vw] portrait:md:max-w-[90vw]

                                transform z-50 rounded-xl flex items-center justify-center
                                data-[enter]:duration-150 data-[enter]:data-[closed]:scale-75
                                data-[leave]:duration-300 data-[leave]:data-[closed]:scale-95"
						>
							<div
								className="form-modal-container h-[90vh] max-h-[90vh]
                                    portrait:md:!h-[90vh] portrait:md:!max-h-[90vh]
                                    landscape:!min-w-[30vw] landscape:!w-[30vw] landscape:!max-w-[30vw]
                                    portrait:!min-w-full portrait:!w-full portrait:!max-w-full
                                    portrait:md:!min-w-[60dvw] portrait:md:!w-[60dvw] portrait:md:!max-w-[60dvw]"
							>
								{/* Header */}
								<div className={"form-modal-header-container"}>
									{/* Header Title | Close Button */}
									<div className={"flex flex-row items-center justify-between"}>
										{/* Form Title */}
										<h2>
											{t("EVENTS_PAGE.REGISTRATION_FORM.TITLE")}
										</h2>

										{/* Close Button */}
										<button onClick={handleClose}>
											<img
												className={"w-[75%] h-[75%]"}
												src={"/assets/close-icon.png"}
												alt={"Close"}
												title={"Close"}
											/>
										</button>
									</div>

									{/* Divider */}
									<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
								</div>

								{/* Body */}
								<div className={"form-modal-body-container ! !flex-1 !max-h-none"}>
									{/* Event Banner */}
									<img
										src={selectedEventDetails.bannerUrl}
										alt={selectedEventDetails.title}
										className="rounded-xl w-full aspect-auto"
									/>

									{/* Registration Form */}
									<div
										className={`flex flex-col justify-between
                                            gap-1 portrait:gap-[1vh] portrait:md:gap-1`}
									>
										{/* Ticket Bearer Details */}
										<div
											className={`flex-1 flex flex-col items-start 
                                                pb-[calc(1vh+0.25rem)] gap-1`}
										>
											{/*
                                                relative after:content-[''] after:absolute
                                                after:right-0 after:bottom-0 after:left-0
                                                after:h-[1.5px] after:bg-[length:10px_1px]
                                                after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]
                                            */}
											{/* Heading */}
											<div className={`w-full flex-1 flex flex-col items-start`}>
												<p
													className={`w-full text-gray-600 font-custom-medium
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight`}
												>
													{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.TITLE")}
												</p>

												{/* Divider */}
												<div
													className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full my-[1vh]"}/>
											</div>

											{/* Details */}
											<div
												className={`w-full flex-1 flex flex-col items-start
                                                    gap-1 portrait:gap-3 portrait:md:gap-1`}
											>
												{/* Full Name */}
												<div
													className={`w-full flex portrait:flex-col
                                                        portrait:md:flex items-center gap-4
                                                        portrait:gap-1 portrait:md:gap-4`}
												>
													<p
														className="w-[37.5%] portrait:w-full portrait:md:w-[37.5%]
                                                            text-[#9B9B9B] font-custom-medium
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight"
													>
														{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.NAME")}
													</p>
													<p
														className="flex-1 portrait:w-full portrait:md:flex-1
                                                            text-gray-900 font-custom-semi-bold
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight"
													>
														{account.firstName + ' ' + account.middleName}
													</p>
												</div>

												{/* Email */}
												<div
													className={`w-full flex portrait:flex-col 
                                                        portrait:md:flex items-center gap-4
                                                        portrait:gap-1 portrait:md:gap-4`}
												>
													<p
														className="w-[37.5%] portrait:w-full portrait:md:w-[37.5%]
                                                            text-[#9B9B9B] font-custom-medium
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight"
													>
														{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.EMAIL")}
													</p>
													<p
														className="flex-1 portrait:w-full portrait:md:flex-1
                                                            text-gray-900 font-custom-semi-bold
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight"
													>
														{account.email}
													</p>
												</div>

												{/* WhatsApp Number */}
												<div
													className={`w-full flex portrait:flex-col 
                                                        portrait:md:flex items-center gap-4
                                                        portrait:gap-1 portrait:md:gap-4`}
												>
													<p
														className="w-[37.5%] portrait:w-full portrait:md:w-[37.5%]
                                                            text-[#9B9B9B] font-custom-medium
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight"
													>
														{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.WHATSAPP_NUMBER")}
													</p>
													<p
														className="flex-1 portrait:w-full portrait:md:flex-1
                                                            text-gray-900 font-custom-semi-bold
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight"
													>
														{account.phone.dialingCode + ' ' + account.phone.number}
													</p>
												</div>

												{/* Mode of Attending */}
												{
													selectedEventDetails.isVirtualModeEnabled && (
														<div
															className={`w-full flex portrait:flex-col 
                                                                portrait:md:flex items-center gap-4
                                                                portrait:gap-1 portrait:md:gap-4`}
														>
															<p
																className={`w-[37.5%] portrait:w-full portrait:md:w-[37.5%]
                                                                    text-[#9B9B9B] font-custom-medium
                                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                                    landscape:lg:text-[1rem] leading-tight`}
															>
																{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.LABEL")}
															</p>

															<p
																className="flex-1 portrait:w-full portrait:md:flex-1
                                                                    text-gray-900 font-custom-semi-bold
                                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                                    landscape:lg:text-[1rem] leading-tight"
															>
																{modeOfAttendingDetails(selectedModeOfAttending).label}
															</p>
														</div>
													)
												}
											</div>
										</div>

										{/* Number of Seats */}
										{
											selectedModeOfAttending === "PHYSICAL" && selectedEventDetails.isTicketed && (
												<div
													className={`flex-1 flex flex-col items-start 
                                                        pb-[calc(1vh+0.25rem)] gap-1`}
												>
													{/*
                                                        relative after:content-[''] after:absolute
                                                        after:right-0 after:bottom-0 after:left-0
                                                        after:h-[1.5px] after:bg-[length:10px_1px]
                                                        after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]
                                                    */}
													{/* Heading */}
													<div className={`w-full flex-1 flex flex-col items-start`}>
														<p
															className={`w-full text-gray-600 font-custom-medium
                                                                portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                                landscape:lg:text-[1rem] leading-tight`}
														>
															{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.NUMBER_OF_SEATS.LABEL")}
														</p>

														{/* Divider */}
														<div
															className={`h-[0.1rem] w-full bg-[#ECECEC]
                                                                rounded-full my-[1vh]`}
														/>
													</div>

													{/* Number of Seats Radio Buttons */}
													<div
														className={`custom-input-multiple-fields-container 
                                                            w-full flex-1`}
													>
														{/* 1 Seat */}
														<label className="custom-input-checkbox">
															<div
																className={`${is1SeatSelected ?
																	'bg-[#FF6600] border-orange-300'
																	: 'bg-white border-[#CBCBCB]'}`}
															>
																<img
																	src={"/assets/tick-icon-light.svg"}
																	alt={"Select"}
																	title={"Select"}
																/>
																<input
																	type="checkbox"
																	className="absolute hidden"
																	checked={is1SeatSelected}
																	onChange={() => {
																		setIs1SeatSelected(!is1SeatSelected);
																		setIs2SeatsSelected(false);
																		handleNumberOfSeatsSelect(1);
																	}}
																/>
															</div>
															<span
																className={`flex-1 flex items-center
                                                                    portrait:gap-[0.5rem] portrait:md:gap-[0.25rem] 
                                                                    portrait:jk:gap-[0.45rem] portrait:lg:gap-[0.75rem]
                                                                    landscape:gap-[0.1rem] landscape:md:gap-[0.15rem]
                                                                    landscape:jk:gap-[0.2rem] landscape:lg:gap-[0.3rem]`}
															>
                                                                <p
	                                                                className={`portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                        landscape:text-[0.8rem] landscape:jk:text-[0.9rem] 
                                                                        landscape:lg:text-[1rem] leading-tight 
                                                                        font-custom-regular text-gray-900`}
                                                                >
                                                                    {numberOfSeatsLabel(1).label}
                                                                </p>
                                                                <img
	                                                                className={`aspect-auto
                                                                        portrait:h-[1.5rem] portrait:md:h-[1.1rem]
                                                                        portrait:jk:h-[1.2rem] portrait:lg:h-[1.6rem]
                                                                        landscape:h-[0.9rem] landscape:md:h-[1rem]
                                                                        landscape:jk:h-[1.1rem] landscape:lg:h-[1.25rem]`}
	                                                                src={"/assets/seats-icon.svg"}
	                                                                alt={t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.NUMBER_OF_SEATS.SEATS.ONE")}
                                                                />
                                                            </span>
														</label>

														{/* 2 Seats */}
														<label className="custom-input-checkbox">
															<div
																className={`${is2SeatsSelected
																	? 'bg-[#FF6600] border-orange-300'
																	: 'bg-white border-[#CBCBCB]'}`}
															>
																<img
																	src={"/assets/tick-icon-light.svg"}
																	alt={"Select"}
																	title={"Select"}
																/>
																<input
																	type="checkbox"
																	checked={is2SeatsSelected}
																	className="absolute hidden"
																	onChange={() => {
																		setIs2SeatsSelected(!is2SeatsSelected);
																		setIs1SeatSelected(false);
																		handleNumberOfSeatsSelect(2);
																	}}
																/>
															</div>
															<span
																className={`flex-1 flex items-center
                                                                    portrait:gap-[0.5rem] portrait:md:gap-[0.25rem] 
                                                                    portrait:jk:gap-[0.45rem] portrait:lg:gap-[0.75rem]
                                                                    landscape:gap-[0.1rem] landscape:md:gap-[0.15rem]
                                                                    landscape:jk:gap-[0.2rem] landscape:lg:gap-[0.3rem]`}
															>
                                                                <p
	                                                                className={`portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                        landscape:text-[0.8rem] landscape:jk:text-[0.9rem] 
                                                                        landscape:lg:text-[1rem] leading-tight 
                                                                        font-custom-regular text-gray-900`}
                                                                >
                                                                    {numberOfSeatsLabel(2).label}
                                                                </p>
                                                                <img
	                                                                className={`aspect-auto
                                                                        portrait:h-[1.5rem] portrait:md:h-[1.1rem]
                                                                        portrait:jk:h-[1.2rem] portrait:lg:h-[1.6rem]
                                                                        landscape:h-[0.9rem] landscape:md:h-[1rem]
                                                                        landscape:jk:h-[1.1rem] landscape:lg:h-[1.25rem]`}
	                                                                src={"/assets/seats-icon.svg"}
	                                                                alt={t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.NUMBER_OF_SEATS.SEATS.TWO")}
                                                                />
                                                                <img
	                                                                className={`aspect-auto
                                                                        portrait:h-[1.5rem] portrait:md:h-[1.1rem]
                                                                        portrait:jk:h-[1.2rem] portrait:lg:h-[1.6rem]
                                                                        landscape:h-[0.9rem] landscape:md:h-[1rem]
                                                                        landscape:jk:h-[1.1rem] landscape:lg:h-[1.25rem]`}
	                                                                src={"/assets/seats-icon.svg"}
	                                                                alt={t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.NUMBER_OF_SEATS.SEATS.TWO")}
                                                                />
                                                            </span>
														</label>
													</div>
												</div>
											)
										}

										{/* Occupation Details */}
										{
											selectedEventDetails.occupationDetailsRequired && (
												<div
													className={`flex-1 flex flex-col items-start 
                                                        pb-[calc(1vh+0.25rem)] gap-1`}
												>
													{/* Heading */}
													<div className={`w-full flex-1 flex flex-col items-start`}>
														<p
															className={`w-full text-gray-600 font-custom-medium
                                                                portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                                landscape:lg:text-[1rem] leading-tight`}
														>
															{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TITLE")}
														</p>

														{/* Divider */}
														<div
															className={`h-[0.1rem] w-full bg-[#ECECEC]
                                                                rounded-full my-[1vh]`}
														/>
													</div>

													{/* Occupation Type */}
													<div className="custom-input-container">
														<label htmlFor="employmentType">
															{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.LABEL")}
														</label>

														<div className="w-full h-full flex flex-col">
															<button
																onBlur={() => {
																	if (!isSelectingOccupationType) {
																		setIsOccupationTypeDropdownOpen(false);
																	}
																}}
																className="custom-input-dropdown-button"
																onClick={() => setIsOccupationTypeDropdownOpen(!isOccupationTypeDropdownOpen)}
															>
																<p className={""}>
																	{occupationTypeLabel(occupationDetails.type)}
																</p>

																<ChevronDownIcon
																	className={`${isOccupationTypeDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
																	aria-hidden="true"
																	stroke="#292D32"
																	strokeWidth={"0.1vh"}
																/>
															</button>

															{/* Occupation Type Dropdown */}
															<div className={"relative"}>
																<Transition show={isOccupationTypeDropdownOpen}>
																	<div
																		className={`bg-white absolute left-0 right-0 z-[100] max-h-[15vh]
                                                                            origin-top-right rounded-md shadow-2xl 
                                                                            border border-gray-700 overflow-y-scroll
                                                                            data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                                            data-[enter]:duration-100 data-[enter]:ease-out 
                                                                            data-[leave]:duration-75 data-[leave]:ease-in`}
																	>
																		<button
																			className="custom-input-dropdown-list-button"
																			onMouseDown={() => setIsSelectingOccupationType(true)}
																			onClick={() => handleOccupationTypeSelect("Business")}
																		>
																			<p className={""}>
																				{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.BUSINESS")}
																			</p>
																		</button>
																		<button
																			className="custom-input-dropdown-list-button"
																			onMouseDown={() => setIsSelectingOccupationType(true)}
																			onClick={() => handleOccupationTypeSelect("Service Professional")}
																		>
																			<p className={""}>
																				{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.SERVICE_PROFESSIONAL")}
																			</p>
																		</button>
																		<button
																			className="custom-input-dropdown-list-button"
																			onMouseDown={() => setIsSelectingOccupationType(true)}
																			onClick={() => handleOccupationTypeSelect("Entrepreneur")}
																		>
																			<p className={""}>
																				{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.ENTREPRENEUR")}
																			</p>
																		</button>
																		<button
																			className="custom-input-dropdown-list-button"
																			onMouseDown={() => setIsSelectingOccupationType(true)}
																			onClick={() => handleOccupationTypeSelect("Freelancer")}
																		>
																			<p className={""}>
																				{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.FREELANCER")}
																			</p>
																		</button>
																		<button
																			className="custom-input-dropdown-list-button"
																			onMouseDown={() => setIsSelectingOccupationType(true)}
																			onClick={() => handleOccupationTypeSelect("Self Employed")}
																		>
																			<p className={""}>
																				{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.SELF_EMPLOYED")}
																			</p>
																		</button>
																		<button
																			className="custom-input-dropdown-list-button"
																			onMouseDown={() => setIsSelectingOccupationType(true)}
																			onClick={() => handleOccupationTypeSelect("Investor")}
																		>
																			<p className={""}>
																				{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.INVESTOR")}
																			</p>
																		</button>
																		<button
																			className="custom-input-dropdown-list-button"
																			onMouseDown={() => setIsSelectingOccupationType(true)}
																			onClick={() => handleOccupationTypeSelect("Student")}
																		>
																			<p className={""}>
																				{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.STUDENT")}
																			</p>
																		</button>
																		<button
																			className="custom-input-dropdown-list-button"
																			onMouseDown={() => setIsSelectingOccupationType(true)}
																			onClick={() => handleOccupationTypeSelect("Other")}
																		>
																			<p className={""}>
																				{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OPTIONS.OTHER")}
																			</p>
																		</button>
																	</div>
																</Transition>
															</div>
														</div>
													</div>

													{/* TextBox for Occupation Type "Other" */}
													{
														occupationDetails.type === "Other" && (
															<div className="custom-input-container">
																<label htmlFor="occupationTypeOtherName">
																	{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OTHER_OCCUPATION.LABEL")}
																</label>

																<div className="flex-1 flex flex-col">
																	<input
																		id="occupationTypeOtherName"
																		className="custom-input"
																		name='occupationTypeOther'
																		value={occupationTypeOtherName}
																		placeholder={t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.TYPE.OTHER_OCCUPATION.PLACEHOLDER")}
																		onChange={(event) => setOccupationTypeOtherName(event.target.value)}
																	/>
																</div>
															</div>
														)
													}

													<div className="custom-input-container">
														<label htmlFor="occupationName">
															{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.OCCUPATION_INFORMATION.NAME.LABEL")}
														</label>

														<div className="flex-1 flex flex-col">
															<input
																id="occupationName"
																className="custom-input"
																name='occupationName'
																value={occupationDetails.name}
																onChange={(event) => {
																	setOccupationDetails(prev => {
																		return {
																			...prev,
																			name: event.target.value,
																		}
																	});
																}}
															/>
														</div>
													</div>
												</div>
											)
										}

										{/* Food Consent */}
										{
											selectedEventDetails.isFoodAvailable && (
												<div
													className={`flex-1 flex flex-col items-start 
                                                        pb-[calc(1vh+0.25rem)]
                                                        
                                                        portrait:gap-y-[0.5rem] portrait:md:gap-y-[0.25rem]
                                                        portrait:jk:gap-y-[0.45rem] portrait:lg:gap-y-[0.75rem]
                                                        
                                                        landscape:gap-y-[0.1rem] landscape:md:gap-y-[0.15rem]
                                                        landscape:jk:gap-y-[0.35rem] landscape:lg:gap-y-[0.5rem]
                                                        
                                                        relative after:content-[''] after:absolute
                                                        after:right-0 after:bottom-0 after:left-0
                                                        after:h-[1.5px] after:bg-[length:10px_1px]
                                                        after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]`}
												>
													{/* Heading */}
													<div className={`w-full flex-1 flex flex-col items-start`}>
														<p
															className={`w-full text-gray-600 font-custom-medium
                                                                portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                                landscape:lg:text-[1rem] leading-tight`}
														>
															{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.FOOD.LABEL")}
														</p>

														{/* Divider */}
														<div
															className={`h-[0.1rem] w-full bg-[#ECECEC]
                                                                rounded-full my-[1vh]`}
														/>

														<p
															className="flex-1 text-gray-900 font-custom-semi-bold
                                                                portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                                landscape:lg:text-[1rem] leading-tight text-left"
														>
															{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.FOOD.MESSAGE", {
																mealOfTheDay: locale === "en"
																	? selectedEventDetails.foodDetails[0].mealOfTheDay
																	: selectedEventDetails.foodDetails[0].mealOfTheDayDevanagariScript,
																location: locale === "en"
																	? selectedEventDetails.foodDetails[0].locationName
																	: selectedEventDetails.foodDetails[0].locationNameDevanagariScript,
															})}
														</p>
													</div>

													{/* Yes | No Radio Buttons */}
													<div
														className={`custom-input-multiple-fields-container 
                                                            w-full flex-1`}
													>
														{/* Yes */}
														<label className="custom-input-checkbox">
															<div
																className={`${isFoodConsentYesSelected ?
																	'bg-[#FF6600] border-orange-300'
																	: 'bg-white border-[#CBCBCB]'}`}
															>
																<img
																	src={"/assets/tick-icon-light.svg"}
																	alt={"Select"}
																	title={"Select"}
																/>
																<input
																	type="checkbox"
																	className="absolute hidden"
																	checked={isFoodConsentYesSelected}
																	onChange={() => {
																		setIsFoodConsentYesSelected(!isFoodConsentYesSelected);
																		setIsFoodConsentNoSelected(false);
																		handleFoodConsentSelect(true);
																	}}
																/>
															</div>
															<p
																className={`portrait:text-[1rem] portrait:md:text-[1rem]
                                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem] 
                                                                    landscape:lg:text-[1rem] leading-tight 
                                                                    font-custom-regular text-gray-900`}
															>
																{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.FOOD.OPTIONS.YES")}
															</p>
														</label>

														{/* No */}
														<label className="custom-input-checkbox">
															<div
																className={`${isFoodConsentNoSelected
																	? 'bg-[#FF6600] border-orange-300'
																	: 'bg-white border-[#CBCBCB]'}`}
															>
																<img
																	src={"/assets/tick-icon-light.svg"}
																	alt={"Select"}
																	title={"Select"}
																/>
																<input
																	type="checkbox"
																	checked={isFoodConsentNoSelected}
																	className="absolute hidden"
																	onChange={() => {
																		setIsFoodConsentNoSelected(!isFoodConsentNoSelected);
																		setIsFoodConsentYesSelected(false);
																		handleFoodConsentSelect(false);
																	}}
																/>
															</div>
															<p
																className={`portrait:text-[1rem] portrait:md:text-[1rem]
                                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem] 
                                                                    landscape:lg:text-[1rem] leading-tight 
                                                                    font-custom-regular text-gray-900`}
															>
																{t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.FOOD.OPTIONS.NO")}
															</p>
														</label>
													</div>
												</div>
											)
										}

										{/* Info (Based on Mode of Attending) | Note */}
										<div className={"gap-2 w-full flex flex-col items-center justify-between"}>
											{/* Information */}
											<p
												className="flex-1 text-gray-900 font-custom-semi-bold
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight text-center"
											>
												{modeOfAttendingDetails(selectedModeOfAttending).info}
											</p>

											{
												selectedModeOfAttending === "PHYSICAL" && (
													<p
														className="flex-1 text-[#6D6D6D] font-custom-medium-italic
                                                            portrait:text-[1rem] portrait:md:text-[0.8rem]
                                                            portrait:jk:text-[1rem] portrait:lg:text-[1.25rem]
                                                            landscape:text-[0.65rem] landscape:md:text-[0.7rem]
                                                            landscape:jk:text-[0.75rem] landscape:lg:text-[0.85rem]
                                                            leading-tight text-center"
													>
														{t("EVENTS_PAGE.BOOKING_NOTE.LABEL")} {selectedEventDetails.manualPaymentConfirmationRequired
														? t("EVENTS_PAGE.BOOKING_NOTE.ID_AND_PAYMENT_PROOF_MESSAGE")
														: t("EVENTS_PAGE.BOOKING_NOTE.ID_PROOF_MESSAGE")}
													</p>
												)
											}
										</div>
									</div>
								</div>

								{/* Footer */}
								<div className={"form-modal-footer-container"}>
									{/* Divider */}
									<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

									{/* Submit Button Container */}
									<div className="flex items-center justify-end">
										{/* Submit Button */}
										<button
											disabled={isBookTicketButtonDisabled}
											onClick={handleSubmit}
											className="form-modal-footer-container-submit-button"
										>
											<p>
												{
													selectedEventDetails.manualPaymentConfirmationRequired
														? t("EVENTS_PAGE.REGISTRATION_FORM.PROCEED_TO_PAYMENT")
														: t("EVENTS_PAGE.REGISTRATION_FORM.BOOK_TICKET")
												}
											</p>
											<svg
												viewBox="0 0 6 6"
												fill="none"
												id={"arrow-icon"}
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M3 1L5 3L3 5"
													id={"arrow-icon-tip"}
													stroke="black"
													strokeLinecap="square"
												/>
												<path
													d="M1 3L4 3"
													id={"arrow-icon-line"}
													stroke="black"
													strokeLinecap="square"
												/>
											</svg>
										</button>
									</div>
								</div>
							</div>
						</div>
					</TransitionChild>
				</div>
			</Transition>
		</>
	);
}
